// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1UO4u","label":"Section_label__2ivcZ","contentWrap":"Section_contentWrap__2p6aX","footer":"Section_footer__3-t8P","footerInner":"Section_footerInner__3dTVq"};